var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"title-chunk"},[(_vm.title || _vm.secondTitle)?_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.secondTitle))]),_vm._t("right")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }